import {
  geoMercator,
  geoPath,
  geoCentroid,
  geoBounds,
  geoDistance,
} from 'd3-geo';
import { observer } from 'mobx-react';
import i_ from 'i18next';
import { withTheme } from '@material-ui/core/styles';
import React from 'react';

import { Row, Column } from '../commons/Containers';
import EditDialog from '../commons/EditDialog';
import SelectField from '../commons/SelectField';
import TextField from '../commons/TextField';

import { loadEnum } from '../../utils/Enums';
import Stores from '../../stores/Stores';
import UIStore from '../../stores/UIStore';

const store = Stores.load('municipio');

const model = {
  nome: '',
  codigoIBGE: '',
  uf: 'PR',
};

class MunicipioEdit extends React.Component {
  componentWillMount() {
    loadEnum('UF').then(data => (this.ufs = data));
  }

  save = () => {
    if (store.edit.id != null) {
      store
        .save()
        .then(() => UIStore.redo(store))
        .catch(UIStore.saveError);
    } else {
      store
        .create()
        .then(data => {
          if (this.props.onSave) {
            this.props.onSave(data);
          }
        })
        .then(() => UIStore.redo(store))
        .catch(UIStore.saveError);
    }
  };

  mapStyle = (feature, layer) => {
    return {
      color: '#640000',
      weight: 1,
      opacity: 0.9,
    };
  };

  render() {
    this.item = store.edit != null ? store.edit : model;
    let width = 400,
      height = 400;
    var mapa = null;
    var projection = null;
    if (this.item.shape) {
      mapa = JSON.parse(this.item.shape);
      let translate = [width / 2, height / 2];
      let bounds = geoBounds(mapa),
        center = geoCentroid(mapa);
      let distance = geoDistance(bounds[0], bounds[1]),
        scale = height / distance / Math.sqrt(2);
      projection = () =>
        geoMercator()
          .translate(translate)
          .center(center)
          .scale(scale);
    }
    return (
      <EditDialog
        title={i_.t('municipio.title', {
          context: this.item.id ? 'edit' : 'new',
          label: this.item.nome,
        })}
        opened={store.edit != null}
        onCancel={() => (store.edit = null)}
        onSave={this.save}
      >
        <Row>
          <Column>
            <TextField entity="municipio" field="nome" item={this.item} />

            <SelectField
              entity="municipio"
              field="uf"
              item={this.item}
              list={this.ufs}
            />

            <TextField entity="municipio" field="codigoIBGE" item={this.item} />
          </Column>

          <Column>
            {mapa ? (
              <svg width={width} height={height}>
                <g className="municipios">
                  <path
                    d={geoPath().projection(projection())(mapa)}
                    className="municipio"
                    fill={this.props.theme.palette.primary.main}
                    stroke="#000"
                    strokeWidth={1}
                  />
                </g>
              </svg>
            ) : (
              ''
            )}
          </Column>
        </Row>
      </EditDialog>
    );
  }
}

export default withTheme()(observer(MunicipioEdit));



// WEBPACK FOOTER //
// ./src/components/municipio/Edit.js